import React from "react";
import { Badge } from "../../../../../components/ui/common/badge";
import RecordEditShell from "../../shared/components/recordList/RecordEditShell";
import RecordStrip from "../../shared/components/recordList/RecordStrip";
import { PackagingMaterialRecord } from "../types/packagingDetail.types";
import PackagingMaterialForm from "./PackagingMaterialForm";
import { toFormValues, weightUnitLabel } from "../utils/packagingMaterial.utils";
import { MaterialFormValues, PackagingTypeOption } from "../types/packagingMaterial.types";

interface PackagingMaterialRowProps {
  material: PackagingMaterialRecord;
  idx: number;
  packagingTypeData: PackagingTypeOption[];
  isEditing: boolean;
  onEdit: () => void;
  onSave: (values: MaterialFormValues) => void;
  onCancelEdit: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

/** One packaging material: a read strip, or (while editing) the inline edit form. */
const PackagingMaterialRow: React.FC<PackagingMaterialRowProps> = ({
  material,
  idx,
  packagingTypeData,
  isEditing,
  onEdit,
  onSave,
  onCancelEdit,
  onDelete,
  disabled = false
}) => {
  if (isEditing) {
    return (
      <RecordEditShell>
        <PackagingMaterialForm
          defaultValues={toFormValues(material)}
          packagingTypeData={packagingTypeData}
          title={`Material ${idx + 1}${material.name ? ` — ${material.name}` : ""}`}
          onDelete={onDelete}
          onSave={onSave}
          onCancel={onCancelEdit}
          disabled={disabled}
        />
      </RecordEditShell>
    );
  }

  const materialLabel =
    packagingTypeData.find(o => String(o.value) === String(material.material))?.text ||
    material.material ||
    "—";

  return (
    <RecordStrip
      idx={idx}
      title={material.name}
      badge={
        <Badge variant="outline" className="tw-text-[10px] tw-h-5 tw-px-1.5">
          {materialLabel}
        </Badge>
      }
      right={
        <>
          {material.weight === "" ? "—" : `${material.weight} ${weightUnitLabel(material.weightUnit)}`}
          {material.cost !== "" && <span className="tw-ml-2">${material.cost}</span>}
        </>
      }
      onEdit={onEdit}
      onDelete={onDelete}
      disabled={disabled}
    />
  );
};

export default PackagingMaterialRow;
